module.exports = __webpack_public_path__ + "static/euphoros-1-dd62684a4853a0b9d6f2a6650c059c00.jpg";